export default "__VITE_ASSET__07d7f250__"